// Route guard: bounces signed-in users *away* from auth pages — but only
// when they've completed signup. A user who exists in Firebase Auth but
// hasn't enrolled MFA is mid-signup (we just created the account; the
// MFA-enrol step renders next). Bouncing them at this point breaks the
// signup flow because `createUserWithEmailAndPassword` signs them in
// synchronously, the auth observer fires, and this guard would evict
// them before MfaEnrollmentStep ever mounts.

import { Navigate } from 'react-router-dom';
import { multiFactor } from 'firebase/auth';
import { useAuth } from '../../contexts/AuthContext';

export default function RequireNoAuth({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();

  if (loading) return null;

  if (user && multiFactor(user).enrolledFactors.length > 0) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
